import React, { ReactNode } from 'react'
import { CssBaseline, ScopedCssBaseline } from '@mui/material'
import { AppProvider, AppConfig } from '../contexts/AppContext'
import { NotificationProvider } from '../contexts/NotificationContext'
import { UIConfigProvider } from '../contexts/UIConfigContext'
import { NPSProvider } from '../contexts/NPSContext'
import { FeedbackButton } from '../features/nps'

interface AppProvidersProps {
  config?: AppConfig
  children: ReactNode
}

/**
 * Detecta se está rodando dentro do WordPress
 */
function isWordPressContext(): boolean {
  return !!(
    (window as any).monkeeTranscription?.ajaxUrl ||
    document.querySelector('meta[name="generator"][content*="WordPress"]') ||
    (window as any).wp ||
    (window as any).wpApiSettings
  )
}

export function AppProviders({ config, children }: AppProvidersProps) {
  // Extrai tenant e player da config ou do window.monkeeTranscription
  const tennant = config?.tennantId || 
    (window as any).monkeeTranscription?.tennantId || 
    'DEFAULT'
  
  const player = config?.userId || 
    (window as any).monkeeTranscription?.userId || 
    undefined
  
  const apiBaseUrl = config?.aiBaseUrl || config?.baseUrl

  const isWP = isWordPressContext()
  
  return (
    <AppProvider config={config}>
      <UIConfigProvider tennant={tennant} player={player} apiBaseUrl={apiBaseUrl}>
        <NotificationProvider>
          <NPSProvider>
            {/* No WordPress, usar ScopedCssBaseline para não resetar o CSS global do tema */}
            {isWP ? (
              <ScopedCssBaseline sx={{ bgcolor: 'transparent' }}>
                {children}
              </ScopedCssBaseline>
            ) : (
              <>
                <CssBaseline />
                {children}
              </>
            )}
            <FeedbackButton />
          </NPSProvider>
        </NotificationProvider>
      </UIConfigProvider>
    </AppProvider>
  )
}

export default AppProviders
